<template>
  <div v-loading.fullscreen.lock="loading" id="settings_personal_info">
		<inner-page-title title="Edit profile" action="Save" @actionClicked="onSaveProfile"></inner-page-title>
		<div style="max-width: 600px" class="container">
			<div>
				<el-row :gutter="20">
					<el-col :sm="10">
						<form-item label="First name">
							<el-input placeholder="First name" v-model="user.first_name"></el-input>
						</form-item>
					</el-col>

					<el-col :sm="10">
						<form-item label="Last name">
							<el-input placeholder="Last name" v-model="user.last_name"></el-input>
						</form-item>
					</el-col>

						<el-col :sm="4">
						<form-item label="Gender">
							<el-select v-model="user.gender" placeholder="Gender">
								<el-option label="Male" value="male"></el-option>
								<el-option label="Female" value="female"></el-option>
								<el-option label="Other" value="other"></el-option>
							</el-select>
						</form-item>
					</el-col>

					<el-col>
						<form-item label="Email">
							<el-input placeholder="Email address" v-model="user.email" disabled></el-input>
						</form-item>
					</el-col>

					<el-col :sm="14">
						<form-item label="Phone number">
							<el-input placeholder="Phone number" v-model="user.phone_number" disabled></el-input>
						</form-item>
					</el-col>

					<el-col :sm="10">
						<form-item label="Age">
							<el-select v-model="user.age" placeholder="Age">
								<el-option :value="22" label="Less than 26 years old"></el-option>
								<el-option :value="30" label="26 to 35 years old"></el-option>
								<el-option :value="40" label="36 to 45 years old"></el-option>
								<el-option :value="50" label="46 to 55 years old"></el-option>
								<el-option :value="60" label="56 to 65 years old"></el-option>
								<el-option :value="70" label="More than 65 years old"></el-option>
							</el-select>
						</form-item>
					</el-col>
				</el-row>
			</div>
		</div>
  </div>
</template>

<script>
import FormItem from '@/components/Form/FormItem';
import firebase from '@/firebase';
import lodash from 'lodash';

export default {
	components: { FormItem },
	data() {
		return {
			user: {},
			loading: false
		}
	},

	methods: {
		onSaveProfile() {
			let form_data = {
				first_name: this.user.first_name,
				last_name: this.user.last_name,
				gender: this.user.gender,
				age: this.user.age
			};

			this.loading = true;

			// Update carpooling details
			this.SharoAPI({ action: 'updateUserProfile', data: form_data }, true).then(result => {

				if (result.data.error) {
					return this.$message({ type: 'error', showClose: true, message: result.data.error_message });
				}

				this.$message({ type: 'success', showClose: true, message: 'Profile updated successfully' });
			}).finally(() => this.loading = false);
		}
	},

	computed: {
		_user() {
			return this.$store.getters.user;
		},

		locations() {
			if (!this.$store.getters.organization || !this.$store.getters.organization.data || !this.$store.getters.organization.data.locations) {
				return [ { id: null, data: { name: 'All '} }];
			}

			return Object.keys(this.$store.getters.organization.data.locations).map(val => { return { id: val, data: this.$store.getters.organization.data.locations[val]}});
		}
	},

	watch: {
		_user: {
			handler(val) {
				this.user = lodash.cloneDeep(val.data || { address: {}});
			},
			immediate: true
		}
	}
}
</script>

<style lang="scss" scoped>
	#settings_personal_info {
		.form-item {
			margin-bottom: 0;
		}

		.profile-image-container {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 15px;

			img {
				border-radius: 50%;
				width: 100%;
				max-width: 120px;
				opacity: 0.3;
			}

			.upload-image {
				position: absolute;
			}
		}
	}
</style>